import { createApi } from '@reduxjs/toolkit/query/react'
import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { GetProductsResponse, GetProductsPayload, GetActiveReferralActionPayload, GetActiveReferralActionResponse } from 'store/api/types'
import { NextApiResponseBody } from 'types/bolt-api/request'
import { CmsJobOffer, CmsProduct } from 'types/cms/collection-types'
import { Language } from 'types/language'

export const cmsApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/cms'
  }),
  endpoints: (builder) => ({
    getJobOffers: builder.query<CmsJobOffer[] | undefined, Language>({
      query: (language) => ({
        method: 'GET',
        url: `/job-offers?locale=${language}`
      }),
      transformResponse: ({ data }: NextApiResponseBody<CmsJobOffer[]>) => data
    }),

    getCmsProducts: builder.query<GetProductsResponse, GetProductsPayload>({
      query: ({ language }) => ({
        method: 'GET',
        url: `/products?locale=${language}`
      }),
      transformResponse: ({ data }: NextApiResponseBody<CmsProduct[]>) => {
        return data!.reduce((acc, product) => {
          acc[product.apiProduct.slug] = product
          return acc
        }, {} as GetProductsResponse)
      }
    }),

    getActiveReferralAction: builder.query<GetActiveReferralActionResponse['action'], GetActiveReferralActionPayload>({
      query: ({ locale }) => ({
        method: 'GET',
        url: `/referral?locale=${locale}`
      }),
      transformResponse: ({ data }: NextApiResponseBody<GetActiveReferralActionResponse>) => {
        return data?.action || null
      }
    })
  }),
  reducerPath: 'cmsApi'
})

export const { useGetJobOffersQuery, useGetCmsProductsQuery, useGetActiveReferralActionQuery } = cmsApi
